import { isSameMonth } from './isSameMonth'

export function isSameDate(date, comparison = new Date()) { 
    return (
        isSameMonth(date, comparison) && date.getDate() === comparison.getDate()
    );
}
